import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import DepotMarker from './marker';

const DepotMarkers = ({ depots, onClick, selectedId }) => (
  <div>
    {_.map(depots, depot => (
      <DepotMarker
        key={depot.id}
        depot={depot}
        onClick={onClick}
        selected={selectedId === depot.id}
      />))}
  </div>
);

DepotMarkers.defaultProps = {
  selectedId: null,
  depots: [],
};

DepotMarkers.propTypes = {
  depots: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  })),
  onClick: PropTypes.func.isRequired,
  selectedId: PropTypes.number,
};

export default DepotMarkers;
